"use client";

import { LazyMotion, MotionConfig, domAnimation } from "motion/react";
import { useEffect, type ReactNode } from "react";

interface Props {
	children: ReactNode;
}

// Подключает облегчённый набор анимаций и отключает сдвиги тем,
// у кого в системе включено «уменьшить движение»
export default function MotionProvider({ children }: Props) {
	// Сообщаем стилям, что скрипты заработали: до этого момента действует страховка
	// из globals.css, которая сама покажет скрытые блоки, если страница так и не ожила
	useEffect(() => {
		document.documentElement.dataset.motion = "ready";
	}, []);

	return (
		<LazyMotion features={domAnimation} strict>
			<MotionConfig reducedMotion="user">{children}</MotionConfig>
		</LazyMotion>
	);
}
